import { render, staticRenderFns } from "./CompanyAdd.vue?vue&type=template&id=ba0f22a4"
import script from "./CompanyAdd.vue?vue&type=script&lang=js"
export * from "./CompanyAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports